import React, { useState } from "react";
import { Button, Grid, Chip } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import { formatDate } from "../../../../../Utilities/Functions";
import FilterForm from "./FilterForm";

const timeRangeOptions = [
  { label: "last1months", value: 1 },
  { label: "last3months", value: 3 },
  { label: "last6months", value: 6 },
  { label: "customDateRange", value: -1 },
];

const FilterPanel = (props) => {
  const {
    classes,
    countryList = [],
    filters,
    onFilterChange,
    onResetFilter,
  } = props;

  const [modalOpen, setModalOpen] = useState(false);

  const { t } = useTranslation();

  const onModalCancel = () => setModalOpen(false);

  const changeFilters = (filters) => {
    setModalOpen(false);
    onFilterChange(filters);
  };

  const openFilterForm = () => {
    setModalOpen(true);
  };

  const resetFilter = () => {
    onResetFilter();
  };

  return (
    <Grid container className={classes.toolbar}>
      <Grid item container xs={8}>
        {filters.timeRange !== -1 && (
          <Grid item>
            <Chip
              style={{ marginRight: 3 }}
              label={t(
                `labels.dashboard.filters.${
                  timeRangeOptions.find((t) => t.value === filters.timeRange)
                    .label
                }`
              )}
            />
          </Grid>
        )}
        {filters.timeRange === -1 && (
          <Grid item>
            <Chip
              style={{ marginRight: 3 }}
              label={`${t(
                "labels.dashboard.filters.dateRangeFrom"
              )} : ${formatDate(filters.fromDate)}`}
            />
          </Grid>
        )}
        {filters.timeRange === -1 && (
          <Grid item>
            <Chip
              style={{ marginRight: 3 }}
              label={`${t(
                "labels.dashboard.filters.dateRangeTo"
              )} : ${formatDate(filters.toDate)}`}
            />
          </Grid>
        )}
        {filters.country && filters.country.value && (
          <Grid item>
            <Chip
              style={{ marginRight: 3 }}
              label={`${t("labels.dashboard.filters.country")} : ${
                filters.country.label
              }`}
            />
          </Grid>
        )}
      </Grid>
      <Grid item container xs={4} justify="flex-end">
        <Grid item>
          <Button
            variant="contained"
            disableElevation
            className={classes.filterContainerMoreButton}
            onClick={resetFilter}
          >
            {t("labels.dashboard.filters.resetFilter")}
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            disableElevation
            className={classes.filterContainerMoreButton}
            onClick={openFilterForm}
          >
            {t("labels.dashboard.filters.filters")}
          </Button>
        </Grid>
      </Grid>
      {modalOpen && (
        <FilterForm
          classes={classes}
          open={modalOpen}
          filters={filters}
          countryList={countryList}
          onClose={onModalCancel}
          onSubmit={changeFilters}
        />
      )}
    </Grid>
  );
};

export default FilterPanel;
